import React, { useCallback } from 'react';
import { useState } from 'react';
import {
  MediaGridContext,
  MediaGridView,
  PrimaryButtonMandatory,
  PrimaryButtonOptional,
  SecondaryButtonMandatory,
  SecondaryButtonOptional
} from './MediaGrid.view';
import { MediaItem, MediaItemSelectedType } from '../../../../models/media';
import { useDidMount } from '../../../../hooks/useDidMount';

type PrimaryButtonType = PrimaryButtonOptional | PrimaryButtonMandatory;
type SecondaryButtonType = SecondaryButtonOptional | SecondaryButtonMandatory;

export type MediaGridControllerProps = PrimaryButtonType &
  SecondaryButtonType & {
    context: MediaGridContext;
    parentWidth?: number;
    mediaItems: MediaItem[];
    selectedMediaItems: MediaItemSelectedType[];
    setSelectedMediaItems: React.Dispatch<React.SetStateAction<MediaItemSelectedType[]>>;
    imagesIdsWithErrorSelected: MediaItemSelectedType[];
    setImagesIdsWithErrorSelected: React.Dispatch<React.SetStateAction<MediaItemSelectedType[]>>;
    isUnsplash?: boolean;
  };

export const MediaGridController = (props: MediaGridControllerProps): JSX.Element => {
  const [showLightboxModal, setShowLightboxModal] = useState<boolean>(false);
  const [selectedMediaItemForLightbox, setSelectedMediaItemForLightbox] = useState<MediaItem | undefined>(undefined);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState<boolean>(false);
  const { selectedMediaItems, setSelectedMediaItems } = props;

  const checkboxHandler = useCallback(
    (mediaItem: MediaItemSelectedType, e: React.MouseEvent<HTMLInputElement>) => {
      if (e.currentTarget.checked) {
        setSelectedMediaItems(prev => [...prev, mediaItem]);
      } else {
        setSelectedMediaItems(prev =>
          prev.filter(selectedItem => selectedItem.id !== mediaItem.id || selectedItem.type !== mediaItem.type)
        );
      }
    },
    [setSelectedMediaItems]
  );

  // when we mount or unmount, we clear the selected
  useDidMount(() => {
    setSelectedMediaItems([]);

    return () => setSelectedMediaItems([]);
  });

  const viewProps = {
    ...props,
    showLightboxModal,
    setShowLightboxModal,
    selectedMediaItemForLightbox,
    setSelectedMediaItemForLightbox,
    selectedMediaItems,
    setSelectedMediaItems,
    showDeleteConfirmationModal,
    setShowDeleteConfirmationModal,
    checkboxHandler
  };

  return <MediaGridView {...viewProps} />;
};
